'use strict';

module.exports = function(Chart) {

	Chart.PolarArea = function(context, config) {
		config.type = 'polarArea';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/chart.js/src/charts/Chart.PolarArea.js
// module id = 283
// module chunks = 0